import {Component, Input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import {debounceTime, Subject, switchMap} from 'rxjs';
import {EVENT_DETAILS} from 'src/app/app-routing.module';
import {environment} from "@environment";
import {AbstractComponent} from "../../abstract.component";
import {ActionResultList, EventItem, FindEventsRequest} from "@model";
import {EventService} from "@services";

@Component({
  selector: 'app-search-bar-events',
  templateUrl: './search-bar-events.component.html',
  styleUrls: ['./search-bar-events.component.scss']
})
export class SearchBarEventsComponent extends AbstractComponent {
  @Input() searchBarClass: string | undefined;

  events: EventItem[] = [];
  inputValue: string = "";
  searchQuery = new Subject();
  showEmptyState: boolean = false;
  isLoading: boolean = false;
  @Input() isTransparent: boolean = false;

  constructor(private eventService: EventService, public translocoService: TranslocoService, private router: Router,
              private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {

    this.subscribeToSearchResult();

    this.subscriptions.push(this.route.queryParams.subscribe(_ => {
      this.events = [];
      this.inputValue = "";
      this.showEmptyState = false;
    }));
  }

  subscribeToSearchResult(): void {
    this.subscriptions.push(this.searchQuery.pipe(
      debounceTime(environment.fullTextSearchDelay), switchMap((searchValue) => {
        return this.eventService.findEventListByName(
          FindEventsRequest.createEventsSearchFilter(<string>searchValue, this.route.snapshot.queryParams['typeOfRace']));
      })).subscribe((value: ActionResultList<EventItem[], number>) => {
      if (value != null && value.result != null && value.result.length > 0 && this.inputValue.length !== 0) {
        this.events = value.result;
        this.showEmptyState = false;
      } else {
        this.events = [];
        if (this.inputValue.length > 0) {
          this.showEmptyState = true;
        }
      }
      this.isLoading = false;
    }));
  }

  public onSearchQueryInput(value: string): void {
    this.inputValue = value;
    if (this.inputValue.length > 1) {
      this.searchQuery.next(this.inputValue.trim());
      this.isLoading = true;
    } else {
      this.events = [];
      this.showEmptyState = false;
      this.isLoading = false;
    }
  }

  public openEventDetails(event: EventItem): void {
    if (event) {
      this.router.navigate([EVENT_DETAILS], {
        relativeTo: this.route,
        queryParams: { eventId: event.id }
      });
    }
  }
}
